import { render, staticRenderFns } from "./Freebies.vue?vue&type=template&id=786f0c08&"
import script from "./Freebies.vue?vue&type=script&lang=js&"
export * from "./Freebies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports